// Per-item body-text overrides for city pages and guide articles.
// Overrides live under the "_pages" namespace of the language overrides object,
// keyed by "city:<slug>" / "article:<slug>".
import { translations } from "./i18n";
import { cities, getCity, cityLabel } from "./mock";
import { articles, getArticle } from "./blog";

// Editable fields shown for a city page (order = display order in the editor).
export const CITY_FIELDS = [
  { key: "heroTitle", label: "Titel (H1)", textarea: false },
  { key: "heroSubtitle", label: "Untertitel (Hero)", textarea: true },
  { key: "introTitle", label: "Abschnitt: Titel", textarea: false },
  { key: "introP1", label: "Abschnitt: Absatz 1", textarea: true },
  { key: "introP2", label: "Abschnitt: Absatz 2", textarea: true },
  { key: "seoHeading", label: "SEO-Block: Titel", textarea: false },
  { key: "seoP1", label: "SEO-Block: Absatz 1", textarea: true },
  { key: "seoP2", label: "SEO-Block: Absatz 2", textarea: true },
  { key: "tasksTitle", label: "Aufgaben-Titel", textarea: false },
];

export const cityDefaults = (slug, lang) => {
  const city = getCity(slug);
  if (!city) return {};
  const name = cityLabel(city, lang);
  const quarters = city.quarters.join(", ");
  const b = translations[lang];
  const cpg = b.cityPage;
  const ce = b.cityExtra;
  return {
    heroTitle: cpg.title(name),
    heroSubtitle: cpg.subtitle(name),
    introTitle: cpg.introTitle(name),
    introP1: cpg.introP1(name),
    introP2: cpg.introP2(name, quarters),
    seoHeading: ce.seoTitle(name),
    seoP1: ce.seoP1(name),
    seoP2: ce.seoP2(name),
    tasksTitle: cpg.tasksTitle(name),
  };
};

// --- Article body <-> plain markup ---
export const serializeBlocks = (content) =>
  (content || [])
    .map((blk) => {
      if (blk.h2) return `## ${blk.h2}`;
      if (blk.p) return blk.p;
      if (blk.ul) return blk.ul.map((x) => `- ${x}`).join("\n");
      return "";
    })
    .join("\n\n");

export const parseBody = (text) => {
  const lines = String(text || "").split(/\r?\n/);
  const blocks = [];
  let ul = null;
  const flush = () => { if (ul) { blocks.push({ ul }); ul = null; } };
  lines.forEach((line) => {
    const s = line.trim();
    if (s === "") { flush(); return; }
    if (s.startsWith("## ")) { flush(); blocks.push({ h2: s.slice(3).trim() }); }
    else if (s.startsWith("- ")) { if (!ul) ul = []; ul.push(s.slice(2).trim()); }
    else { flush(); blocks.push({ p: s }); }
  });
  flush();
  return blocks;
};

export const articleDefaults = (slug) => {
  const a = getArticle(slug);
  if (!a) return { title: "", excerpt: "", body: "" };
  return { title: a.title, excerpt: a.excerpt, body: serializeBlocks(a.content) };
};

export const CITY_LIST = cities.map((c) => ({ slug: c.slug, name: c.name }));
export const ARTICLE_LIST = articles.map((a) => ({ slug: a.slug, title: a.title }));
